angular.module('picmonicng').directive('toasterAchievement', [
  function () {
    return {
      template:
        '<div class="flex-box">' +
        '<div class="m-r-1">' +
        '<achievement-badge achievement="directiveData.achievement"></achievement-badge>' +
        '</div>' +
        '<div>' +
        "<strong class=\"pls-magnum\">{{directiveData.achievement.name}} {{ directiveData.achievement.level == 1 ? 'Unlocked' : directiveData.achievement.level == directiveData.achievement.levels.length - 1 ? 'Completed' : 'Upgraded' }}!</strong>" +
        '<br/>' +
        '<br/>' +
        '<div class="pls-magnum">{{directiveData.achievement.levels[directiveData.achievement.level - 1].desc}}</div>' +
        '<br/>' +
        '<a href="/achievements" style="color: #676767;" target="_blank" class="underline">See my achievements</a>' +
        '</div>' +
        '</div>',
    };
  },
]);
